import { validateDomain } from '../../DNS/models/Domain'

export const FacebookCom = validateDomain('facebook.com')

export const TwitterCom = validateDomain('twitter.com')

export const TelegramOrg = validateDomain('telegram.org')

export const DiscordCom = validateDomain('discord.com')

export const InstagramCom = validateDomain('instagram.com')

export const PinterestCom = validateDomain('pinterest.com')

export const YouTubeCom = validateDomain('youtube.com')

export const MediumCom = validateDomain('medium.com')

export const GitHubCom = validateDomain('github.com')

export const LinkedInCom = validateDomain('linkedin.com')

export const AnchorFm = validateDomain('anchor.fm')

export const RedditCom = validateDomain('reddit.com')
